import { render, staticRenderFns } from "./CalculateBox.vue?vue&type=template&id=3ae7eda8&"
import script from "./CalculateBox.vue?vue&type=script&lang=js&"
export * from "./CalculateBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports